import { productColors } from "@irati/ui/src/global/colors";
import Products from "../enums/Products";
var productsUI = function (formatMessage) {
    var _a;
    return (_a = {},
        _a[Products.perks] = {
            color: productColors.perks,
            icon: "products-perks",
            text: formatMessage({ id: "platform.products.perks.text" }),
            title: formatMessage({ id: "platform.products.perks.title" })
        },
        _a[Products.insights] = {
            color: productColors.insights,
            icon: "products-insights",
            text: formatMessage({ id: "platform.products.insights.text" }),
            title: formatMessage({ id: "platform.products.insights.title" })
        },
        _a[Products.medical] = {
            color: productColors.medical,
            icon: "products-medical",
            text: formatMessage({ id: "platform.products.medical.text" }),
            title: formatMessage({ id: "platform.products.medical.title" })
        },
        _a[Products.recognition] = {
            color: productColors.recognition,
            icon: "products-recognition",
            text: formatMessage({ id: "platform.products.recognition.text" }),
            title: formatMessage({ id: "platform.products.recognition.title" })
        },
        _a);
};
export default productsUI;
